function modalInit() {
	$('a.close-modal').on('click', function (e) {
		e.preventDefault();
		closeModal();
	});

	// Combine panel open/close triggers for better maintainability
	$('button.panel-close, a.panel-close').on('click', function (e) {
		e.preventDefault();
		closePanel();
	});

	$('.btn.panel-open, .has-panel-trigger a.btn, .has-panel-trigger.btn > a').on('click', function (e) {
		e.preventDefault();

		if ($('body').hasClass('panel--visible')) {
			closePanel();
		} else {
			openPanel();
		}
	});

	$('.has-panel-trigger a.btn').on('click', function (e) {
		e.preventDefault();
		openPanel();
	});

	// Close modal on background click
	$(document).on('click', '.modal-window__background', function (e) {
		e.preventDefault();
		closeModal();
	});

	// Close panel on background overlay click
	$(document).on('click', '.form-bg-overlay', function (e) {
		e.preventDefault();
		closePanel();
	});

	// Close modal or panel on ESC key
	$(document).keyup(function (e) {
		if (e.keyCode === 27) { // ESC key
			if ($('body').hasClass('modal--open')) {
				closeModal();
			}
			if ($('body').hasClass('panel--visible')) {
				closePanel();
			}
		}
	});
}
